import { DEFAULT_LANGUAGE } from 'config/languages';
import { getTranslation } from 'lib/dataTransform';
import DynamicStageChip from 'lib/components/dynamic-stage-chip/DynamicStageChip';

import './SkippedQuestionsList.scss';

/** Questions a dynamic modification rule left out of an inspection. */
export default function SkippedQuestionsList({ skipped = [], title = 'Skipped by dynamic modification' }) {
  if (!skipped.length) return null;

  return (
    <div className='qm-skipped-questions-list' data-testid='SkippedQuestionsList'>
      <h5>{title}</h5>
      <p className='skipped-hint'>
        These questions were not asked: their rule is at a skip stage for this
        product and factory.
      </p>
      <ul>
        {skipped.map((question) => (
          <li key={question.id}>
            <span className='skipped-name'>
              {getTranslation(question.questionName || [], DEFAULT_LANGUAGE).display}
            </span>
            <span className='skipped-meta'>
              {question.groupName}
              {' · '}
              {question.ruleName}
            </span>
            <DynamicStageChip stage={question.stage} />
          </li>
        ))}
      </ul>
    </div>
  );
}
